<div class="qr-scanner">
  <div class="flex items-start justify-between gap-3 px-5 pt-4">
    <div>
      <h2 class="m-0 text-lg font-semibold text-slate-900">Quét mã QR sản phẩm</h2>
      <p class="m-0 mt-0.5 text-sm text-slate-600">Đưa mã QR vào giữa khung để tự động nhận diện.</p>
    </div>
    <button mat-icon-button type="button" aria-label="Đóng" (click)="close()">
      <mat-icon svgIcon="hero:close"></mat-icon>
    </button>
  </div>

  <div class="px-5 pt-4">
    <div class="qr-viewport" [class.qr-viewport-off]="status() === 'error'">
      <video #video class="qr-video" playsinline muted autoplay aria-label="Hình ảnh từ camera"></video>

      @if (status() !== 'error') {
        <div class="qr-frame" aria-hidden="true">
          <span class="qr-corner qr-corner-tl"></span>
          <span class="qr-corner qr-corner-tr"></span>
          <span class="qr-corner qr-corner-bl"></span>
          <span class="qr-corner qr-corner-br"></span>
          @if (status() === 'scanning') {
            <span class="qr-scanline"></span>
          }
        </div>
        <p class="qr-hint" role="status">
          {{ status() === 'starting' ? 'Đang bật camera...' : 'Đang tìm mã QR...' }}
        </p>
      } @else {
        <div class="qr-off-note">
          <mat-icon svgIcon="hero:camera"></mat-icon>
          <span>Camera chưa sẵn sàng</span>
        </div>
      }
    </div>
  </div>

  @if (error(); as err) {
    <div
      role="alert"
      class="mx-5 mt-4 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2.5 text-sm text-amber-900"
    >
      {{ err.message }}
      @if (err.code === 'denied' || err.code === 'in-use' || err.code === 'unknown') {
        <button type="button" class="ml-1 font-semibold text-emerald-700 underline" (click)="retry()">
          Thử lại
        </button>
      }
    </div>
  }

  <div class="space-y-3 px-5 pb-5 pt-4">
    <label
      class="flex cursor-pointer items-center justify-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50"
      [class.opacity-60]="decodingFile()"
    >
      <mat-icon class="!h-5 !w-5 text-emerald-700" svgIcon="hero:camera"></mat-icon>
      {{ decodingFile() ? 'Đang đọc ảnh...' : 'Chụp hoặc chọn ảnh mã QR' }}
      <input
        type="file"
        accept="image/*"
        capture="environment"
        class="sr-only"
        [disabled]="decodingFile()"
        (change)="onFileSelected($event)"
      />
    </label>
    @if (fileMessage()) {
      <p class="m-0 text-sm text-red-600" role="alert">{{ fileMessage() }}</p>
    }

    <form class="flex gap-2" (ngSubmit)="submitManual()">
      <input
        name="manual-code"
        type="text"
        autocomplete="off"
        class="min-w-0 flex-1 rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-900 outline-none focus:border-emerald-600 focus:ring-2 focus:ring-emerald-100"
        placeholder="Hoặc nhập mã / ID sản phẩm"
        aria-label="Mã hoặc ID sản phẩm"
        [ngModel]="manualCode()"
        (ngModelChange)="manualCode.set($event)"
      />
      <button mat-flat-button color="primary" type="submit" [disabled]="!manualCode().trim()">Tra cứu</button>
    </form>
  </div>
</div>
